import { WorkflowOperation } from "./WorkflowOperation";
import { ReceptionManager } from "../reception";

// 対応責任者履歴model
export class ManagerReference {
  // 実施情報
  public operation: WorkflowOperation;

  // ユーザー
  public managers: ReceptionManager[];
}
